export enum AmountSelectorType {
  Percent = 'percent',
  Fixed = 'fixed'
}
